
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M33.05 36.34V58.5h-5.91V36.34"}}),_c('path',{attrs:{"d":"M24.77 36.43V5.64a4.14 4.14 0 118.27 0v30.79zM14.71 11.86v10.77s0 4.13-5.32 4.13-5.32-4.13-5.32-4.13V11.86M9.39 11.86v22.36M6.43 58.5V36.88a3 3 0 015.91 0V58.5zM49.39 26.41v7.81M46.43 58.5V36.88a3 3 0 015.91 0V58.5z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('ellipse',{attrs:{"cx":"49.39","cy":"18.53","rx":"6.55","ry":"8.73","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    